// extracted by mini-css-extract-plugin
export var errorsContainer = "_ti-1";
export var link = "_ti-0";